// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__ERVr8","actionsCol":"EnrolledClinics_actionsCol__125wG"};